import React from 'react';
import qs from 'qs';
import { useHistory } from 'react-router-dom';
import { styled } from 'linaria/react';
import { useLocation } from 'react-router-dom';
import GetStores from './GetStores.gql';
import { useQuery } from 'react-apollo';

const StoreFilter = styled('div')`
  max-width: 220px;
  border-bottom: 1px solid #dedede;
  > div {
    display: flex;
    align-items: center;
    font-size: 14px;
    padding-bottom: 12px;
  }
  select {
    width: 100%;
    margin-bottom: 24px;
  }
  input {
    margin-right: 8px;
    height: 22px;
    width: 22px;
  }
`;

export const removeStoreIdFromUrl = (history, location) => {
  // Get the current URL
  const url = new URL(window.location);

  const parsedParams = qs.parse(url.search, { ignoreQueryPrefix: true });
  delete parsedParams.storeid;
  const newQueryString = qs.stringify(parsedParams, { encode: false });

  history.push(`${location.pathname}?${newQueryString}`);
};

const StoreFilterOptions = ({
  activeStoreFilter,
  setActiveStoreFilter,
  callBackStoreId,
  filterByStore,
  storeId
}) => {
  const location = useLocation();
  const history = useHistory();

  const { data: storeData } = useQuery(GetStores, {
    variables: { includeInactive: false }
  });

  const addUrlParam = (key, value) => {
    const parsedQuery = qs.parse(window.location.search);

    parsedQuery[key] = value;

    const updatedQuery = qs.stringify(parsedQuery, {
      encode: false,
      arrayFormat: 'indices'
    });

    history.push(`${location.pathname}${updatedQuery}`);
  };

  return (
    <StoreFilter>
      <div>
        <input
          style={{ appearance: 'checkbox' }}
          type="checkbox"
          id="store-filter"
          name="store-filter"
          checked={activeStoreFilter}
          onChange={() => {
            if (activeStoreFilter) {
              removeStoreIdFromUrl(history, location);
            }
            setActiveStoreFilter(!activeStoreFilter);
          }}
        />
        <label>Butiksfilter</label>
      </div>
      {activeStoreFilter && (
        <>
          <select
            value={storeId} // Make sure this is a controlled component
            onChange={event => {
              callBackStoreId(event.target.value); // Set the selected storeId
              filterByStore(event.target.value); // Call your filter function with the selected store
              addUrlParam('storeid', event.target.value);
            }}
          >
            <option>Välj butik</option>
            {storeData?.stores?.map(store => (
              <option key={store.id} value={store.id}>
                {store.name}
              </option>
            ))}
          </select>
        </>
      )}
    </StoreFilter>
  );
};

export default StoreFilterOptions;
